(function () {
  'use strict';
  if (window.WarehouseInventoryBadges) return;

  var dataSelector = 'script[data-warehouse-inventory]';
  var optionSelector = '.single-option-selector, .swatch_opt, select[name="id"], input[name="id"]';
  var timers = new WeakMap();

  function hasStock(warehouse) {
    if (!warehouse || typeof warehouse.status !== 'string') return false;
    var status = warehouse.status.trim().toLowerCase();
    if (status !== 'available' && status !== '可用') return false;
    var quantity = warehouse.quantity;
    if (typeof quantity !== 'number' && typeof quantity !== 'string') return false;
    if (typeof quantity === 'string' && !/^-?\d+(?:\.\d+)?$/.test(quantity.trim())) return false;
    return isFinite(Number(quantity)) && Number(quantity) > 0;
  }

  function warehouseFor(variant) {
    // Display exception first; inventory stays unchanged for every variant.
    if (variant && variant.excludeWarehouseBadge === true) return '';
    var warehouses = variant && variant.warehouses;
    if (!warehouses || typeof warehouses !== 'object') return '';
    if (hasStock(warehouses.us)) return 'us';
    if (hasStock(warehouses.local)) return 'local';
    return '';
  }

  function findVariant(variants, options) {
    var matches = variants.filter(function (variant) {
      return Array.isArray(variant.options) && variant.options.length === options.length &&
        options.every(function (value, index) { return value !== undefined && value !== null && variant.options[index] === value; });
    });
    // Never guess a different combination or an ambiguous variant.
    return matches.length === 1 ? matches[0] : null;
  }

  function readData(form) {
    var script = form.querySelector(dataSelector);
    try {
      var data = JSON.parse(script ? script.textContent : '{}');
      return { variants: Array.isArray(data.variants) ? data.variants : [], assets: data.assets || {} };
    } catch (error) {
      return { variants: [], assets: {} };
    }
  }

  function selectedOptions(form, variants) {
    var id = form.querySelector('select[name="id"], input[name="id"]');
    var selected = variants.filter(function (variant) { return id && String(variant.id) === id.value; })[0];
    if (!selected && variants.length === 1) selected = variants[0];
    var count = variants.reduce(function (length, variant) { return Math.max(length, (variant.options || []).length); }, 0);
    var options = selected && Array.isArray(selected.options) ? selected.options.slice() : new Array(count);
    // The theme's hidden selects are canonical. Checked radios are only a fallback
    // for an instance without those selects, so stale radios cannot override them.
    form.querySelectorAll('.swatch[data-option-index]').forEach(function (group) {
      var input = group.querySelector('input[type="radio"]:checked');
      if (input) options[Number(group.getAttribute('data-option-index'))] = input.value;
    });
    form.querySelectorAll('.single-option-selector').forEach(function (select, index) {
      var named = /^option(\d+)$/.exec(select.getAttribute('data-index') || '');
      options[named ? Number(named[1]) - 1 : index] = select.value;
    });
    // Array#every skips holes; fill absent options so incomplete selections fail closed.
    return Array.from({ length: count }, function (_, index) { return options[index]; });
  }

  function renderBadge(badge, warehouse, assets) {
    var src = warehouse && assets[warehouse];
    if (typeof src !== 'string' || !src.trim()) {
      badge.textContent = '';
      badge.removeAttribute('data-warehouse');
      badge.hidden = true;
      return;
    }
    var image = badge.querySelector('img');
    if (!image || image.getAttribute('src') !== src || badge.getAttribute('data-warehouse') !== warehouse) {
      badge.textContent = '';
      image = document.createElement('img');
      image.alt = warehouse === 'us' ? 'US Warehouse' : '48 hours';
      image.width = 90;
      image.height = 30;
      image.draggable = false;
      image.addEventListener('error', function () {
        if (image.parentNode === badge) {
          badge.textContent = '';
          badge.hidden = true;
          badge.removeAttribute('data-warehouse');
          var single = badge.closest('[data-warehouse-single]');
          if (single) single.hidden = true;
        }
      });
      image.src = src;
      badge.appendChild(image);
    }
    badge.setAttribute('data-warehouse', warehouse);
    badge.hidden = false;
  }

  function refreshForm(form) {
    if (!form || !form.isConnected) return;
    var data = readData(form);
    var options = selectedOptions(form, data.variants);
    var groups = form.querySelectorAll('.swatch[data-warehouse-option]');
    groups.forEach(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      group.querySelectorAll('.swatch-element[data-value]').forEach(function (element) {
        var badge = element.querySelector('[data-warehouse-badge]');
        if (!badge) return;
        var candidate = options.slice();
        candidate[index] = element.getAttribute('data-value');
        var variant = Number.isInteger(index) && index >= 0 && index < options.length ? findVariant(data.variants, candidate) : null;
        renderBadge(badge, warehouseFor(variant), data.assets);
      });
    });
    form.querySelectorAll('[data-warehouse-single]').forEach(function (single) {
      var warehouse = groups.length ? '' : warehouseFor(findVariant(data.variants, options));
      var badge = single.querySelector('[data-warehouse-badge]');
      if (badge) renderBadge(badge, warehouse, data.assets);
      single.hidden = !badge || badge.hidden;
    });
  }

  function formsWithin(root) {
    root = root && root.querySelectorAll ? root : document;
    var forms = new Set();
    var ownedSelector = dataSelector + ', [data-warehouse-single]';
    if (root.matches && root.matches('form') && root.querySelector(ownedSelector)) forms.add(root);
    var owner = root.closest && root.closest('form');
    if (owner && owner.querySelector(ownedSelector)) forms.add(owner);
    root.querySelectorAll(ownedSelector).forEach(function (script) {
      var form = script.closest('form');
      if (form) forms.add(form);
    });
    return forms;
  }

  function refresh(root) { formsWithin(root).forEach(refreshForm); }

  function schedule(root) {
    formsWithin(root).forEach(function (form) {
      var pending = timers.get(form) || [];
      pending.forEach(window.clearTimeout);
      // Swatch -> select -> slate.Variants updates run before these reads.
      timers.set(form, [0, 80].map(function (delay) {
        return window.setTimeout(function () { refreshForm(form); }, delay);
      }));
    });
  }

  function onOptionChange(event) {
    if (event.target && event.target.matches && event.target.matches(optionSelector)) schedule(event.target);
  }

  document.addEventListener('change', onOptionChange);
  document.addEventListener('input', onOptionChange);
  document.addEventListener('shopify:section:load', function (event) { schedule(event.target); });
  document.addEventListener('variantChange', function (event) { schedule(event.target); });
  var jqueryBound = false;
  function bindJQuery() {
    if (!window.jQuery || jqueryBound) return;
    jqueryBound = true;
    window.jQuery(document).on('variantChange.warehouseBadges', function (event) { schedule(event.target); });
    window.jQuery(document).on('change.warehouseBadges', optionSelector, onOptionChange);
  }

  function initialize() {
    bindJQuery();
    refresh(document);
  }
  document.addEventListener('DOMContentLoaded', initialize);
  window.addEventListener('load', initialize);
  initialize();

  // Dynamic sections carry their own Liquid snapshot. Observe insertion only;
  // ignore our own image mutations to avoid a render/observer feedback loop.
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.target.nodeType === 1 && record.target.closest('[data-warehouse-badge]')) return;
      var dataChanged = record.target.nodeType === 1 ? record.target.closest(dataSelector) : record.target.parentElement && record.target.parentElement.closest(dataSelector);
      if (dataChanged) schedule(dataChanged);
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1 || node.closest('[data-warehouse-badge]')) return;
        if (node.matches(dataSelector) || node.querySelector(dataSelector) || node.matches('.swatch, .single-option-selector')) schedule(node);
      });
      record.removedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.matches(dataSelector) || node.querySelector(dataSelector))) schedule(record.target);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // Refresh only the DOM and JSON already present; no data fetching or global overrides.
  window.WarehouseInventoryBadges = { refresh: refresh };
})();
